<script setup>
import { object, string } from 'yup';

const props = defineProps({
  formData: {
    type: Object,
    default: () => ({}),
  },

  isShowRecaptcha: {
    type: Boolean,
  },
});

const emit = defineEmits(['update', 'submit']);

const veeFormRef = ref();

//<editor-fold desc="Validation rules">
const validationSchema = object({
  name: string()
    .required()
    .trim()
    .matches(/^[a-zA-Z- ]*$/, 'Field can only contain letters and dashes'),
  email: string().required().email().trim(),
  message: string().required().trim(),
});
// </editor-fold>

//<editor-fold desc="UPDATE-FORM">
const nameData = computed({
  get() {
    return props.formData.name;
  },
  set(value) {
    emit('update', { key: 'name', value });
  },
});

const emailData = computed({
  get() {
    return props.formData.email;
  },
  set(value) {
    emit('update', { key: 'email', value });
  },
});

const messageData = computed({
  get() {
    return props.formData.message;
  },
  set(value) {
    emit('update', { key: 'message', value });
  },
});
// </editor-fold>

function onFormSubmit(values, actions) {
  return new Promise((resolve, reject) => {
    emit('submit', values, { resolve, reject }, actions);
  });
}
</script>

<template>
  <div class="form-contact-us">
    <VeeForm
      ref="veeFormRef"
      v-slot="{ isSubmitting }"
      class="form-contact-us__form"
      :validation-schema="validationSchema"
      @submit="onFormSubmit"
    >
      <fieldset name="Контактная информация" class="form-contact-us__inputs">
        <UiFormInput v-model="nameData" placeholder="name" name="name" />

        <UiFormInput
          v-model="emailData"
          name="email"
          type="email"
          input-mode="email"
          placeholder="email"
        />

        <UiFormTextarea
          v-model="messageData"
          name="message"
          placeholder="message"
        />
      </fieldset>

      <div class="form-contact-us__actions">
        <UiButtonMain
          class="form-contact-us__button form-contact-us__button--send"
          :loading="isSubmitting"
          text="send"
          type="submit"
        />

        <transition name="fade">
          <div v-if="props.isShowRecaptcha" class="form-contact-us__recaptcha">
            <span
              class="form-contact-us__font form-contact-us__font--recaptcha"
            >
              click to confirm<br />
              you’re not a robot
            </span>
          </div>
        </transition>
      </div>
    </VeeForm>
  </div>
</template>

<style scoped lang="scss">
.form-contact-us {
  &__font {
    &--recaptcha {
      font-family: $font-family-second;
      font-size: em(16);
      font-weight: 500;
      line-height: 100%;

      @include media-breakpoint-down(md) {
        font-size: em(13);
      }

      @include media-breakpoint-down(sm) {
        font-size: em(12);
      }
    }
  }

  &__form {
  }

  &__inputs {
  }

  &__actions {
    display: flex;
    align-items: center;
    margin-top: em(20);

    @include media-breakpoint-down(md) {
      margin-top: em(17);
    }

    @include media-breakpoint-down(sm) {
      margin-top: em(8);
    }
  }

  &__recaptcha {
    margin-left: em(40);
    color: $accent-red;

    @include media-breakpoint-down(md) {
      margin-left: em(32);
    }
  }

  &__button {
    &--send {
      width: em(220);

      @include media-breakpoint-down(md) {
        width: em(176);
      }

      @include media-breakpoint-down(sm) {
        width: em(141);
      }
    }
  }
}
</style>
